type Theme = 'back' | 'exit';

const BackButton = ({
  hideButton = false,
  theme = 'back',
}: {
  hideButton?: boolean;
  theme?: Theme;
}): JSX.Element => {
  const themeClasses = {
    back: 'ac-back-button ch-ba--0 ch-bg--grey-2 ch-color--ac-black ch-rounded--md ch-fs--3 ch-pv--1 ch-ph--2 ch-mt--3 sm:ch-mt--5 ch-mb--4',
    exit: 'ac-exit-button ch-ba--0 ch-bg--grey-3 ch-color--ac-black ch-rounded--sm ch-fs--1 ch-fw--500',
  };

  return (
    <div className={`ac-${theme}-button--wrapper ch-mr--auto`}>
      {hideButton ||
      typeof window === 'undefined' ||
      !document.referrer.includes(window.origin) ? null : (
        <button
          className={themeClasses[theme]}
          onClick={() => window.history.back()}
          type="button"
        >
          {theme === 'back' ? 'Back' : 'Exit'}
        </button>
      )}
    </div>
  );
};

export default BackButton;
